<template>
  <div>
    <div class="modal-pdv show modal-full" id="modalPesquisar" tabindex="-1" v-if="modal === 1">
      <div class="modal-pdv-content pt-2">
        <div class="px-3">
          <div class="row no-gutters mb-3 mb-md-0" style="min-height: 70px">
            <div class="col-6 col-md-2 pr-2 mb-2" v-show="!selecionadas.length">
              <label class="small font-weight-bold mb-0">Status</label>
              <select class="form-control" v-model="pesquisa.status" @change="buscarComandas(true)">
                <option value="">Todos</option>
                <option value="1">Abertas</option>
                <option value="2">Fechadas</option>
                <option value="3">Canceladas</option>
              </select>
            </div>
            <div class="col-6 col-md-2 pr-md-2 mb-2" v-if="!tipo && !selecionadas.length">
              <label class="small font-weight-bold mb-0">Tipo de Venda</label>
              <select class="form-control" v-model="pesquisa.tipo" @change="buscarComandas(true)">
                <option value="">Todos</option>
                <option value="1">Mesa</option>
                <option value="2">Delivery</option>
                <option value="3">Comanda</option>
                <option value="4">Venda Rápida</option>
                <option value="5">Balcão</option>
                <option value="6">LeCard</option>
                <option value="7">iFood</option>
                <option value="8">UaiRango</option>
              </select>
            </div>
            <div class="col-md-2 pr-2 mb-2" v-show="!selecionadas.length && user.acessos.restringir_vendas === '0'">
              <label class="small font-weight-bold mb-0">Atendente</label>
              <select class="form-control" v-model="pesquisa.id_usuario" @change="buscarComandas(true)" @click="buscarColaboradores()">
                <option value="">Todos</option>
                <option :value="c.id_usuario" v-for="c in colaboradores">{{ c.nome }}</option>
              </select>
            </div>
            <div class="col-md-3 pr-md-2 mb-2" v-show="!selecionadas.length">
              <label class="small font-weight-bold mb-0">Data da Venda</label>
              <input type="date" placeholder="Data da comanda" class="form-control" v-model="pesquisa.data" @change="buscarComandas(true)">
            </div>
            <div class="col-md-3 mb-2" v-show="!selecionadas.length">
              <label class="small font-weight-bold mb-0">Número da Venda</label>
              <div class="d-flex">
                <input type="text" placeholder="Pesquisar venda" class="form-control" v-model="pesquisa.id" @keyup.enter="buscarComandas(true)">
                <button class="btn btn-info text-nowrap ml-1" @click="buscarComandas(true)"><i class="fa fa-search"></i><span class="d-md-none ml-2">Pesquisar</span></button>
              </div>
            </div>
            <div class="col-sm-6 mt-2" v-show="selecionadas.length && user.admin">
              <button class="btn btn-dark btn-sm mr-2" @click="openRelatorio(1)"><i class="fa fa-file-pdf mr-1"></i> Produtos</button>
            </div>
            <div v-if="podeGerenciarVendas" v-show="selecionadas.length" class="col-sm-6 ml-auto text-right mt-2">
              <button class="btn btn-success btn-sm mr-2" @click="solicitarFinalizar()"><i class="fa fa-wallet mr-1"></i> Fechar</button>
              <button class="btn btn-secondary btn-sm" @click="solcitarCancelamento()"><i class="fa fa-trash-alt mr-1"></i> Cancelar</button>
            </div>
          </div>
        </div>
        <div class="height-90 px-3">
          <div class="table-responsive border-top">
            <loading v-if="load"/>
            <table class="table table-sm mb-0" v-else>
              <tr class="small">
                <th v-if="comandas && comandas.length && podeGerenciarVendas" style="width: 35px">
                  <input class="mb-0" type="checkbox" id="selTodos" :disabled="pesquisa.status !== '1'" @change="selecionarVendas" :checked="selecionadas.length === comandas.length"/>
                </th>
                <th>
                  <label for="selTodos" class="pointer mb-0">Vendas</label><b v-if="selecionadas.length"> ({{ selecionadas.length }})</b>
                </th>
                <th class="text-right"><a href="javascript:" id="limparBusca" class="text-primary" @click="limparSearch"><u>Limpar pesquisa</u></a></th>
              </tr>
              <tr v-for="(c, index) in comandas" :key="index">
                <td v-if="podeGerenciarVendas">
                  <label class="m-0 d-block" :for="'selComanda' + index">
                    <input type="checkbox" :id="'selComanda' + index" v-model="selecionadas" :value="c.id_comanda" :disabled="c.status !== '1'"/>
                  </label>
                </td>
                <td class="pointer py-2" @click="openComanda(c)">
                  <a href="javascript:" :id="'venda' + index" class="d-block text-dark text-decoration-none">
                    <div class="d-flex align-items-end">
                      <div class="font-weight-bold h6 mb-0">
                        <span v-if="c.tipo_comanda === '1'">Mesa: {{c.mesa}}</span>
                        <span v-else-if="c.tipo_comanda === '2'">{{ c.pedido_delivery ? getEnumDelivery(c) : "Delivery"}}</span>
                        <span v-else-if="c.tipo_comanda === '3'">Comanda: {{c.ref_comanda}}</span>
                        <span v-else-if="c.tipo_comanda === '5'">Balcão</span>
                        <span v-else>Venda Rápida</span>
                        <small class="ml-1" v-if="c.nome_cliente">({{c.nome_cliente}})</small>
                      </div>
                      <div class="ml-2">
                        <span class="badge badge-success mr-1" v-if="c.status === '1'">Aberta</span>
                        <span class="badge badge-dark mr-1" v-if="c.status === '2'">Fechada</span>
                        <span class="badge badge-danger mr-1" v-else-if="c.status === '3'">Cancelada</span>
                        <span class="badge badge-warning mr-1" v-else-if="c.status === '4'">Pendente</span>
                        <span class="badge badge-info mr-1" v-if="c.tipo_pedido && c.tipo_pedido.includes('1')">Entregar Pedido</span>
                        <span class="badge badge-primary" v-else-if="c.tipo_pedido && c.tipo_pedido.includes('2')">Retirar no Local</span>
                      </div>
                    </div>
                    <div class="small">#{{c.id_contador || c.id_comanda}} | {{c.data_comanda}} | {{c.vendedor}}</div>
                    <div class="small" v-if="c.data_finalizacao">Fechamento: {{c.data_finalizacao}}</div>
                    <div class="small" v-if="c.pagamentos">Pagamento: {{c.pagamentos}}</div>
                    <div class="small" v-if="c.valor_total > 0">Total: {{c.valor_total | valor}}</div>
                    <div class="small" v-if="c.observacao"><b>Obs:</b> {{c.observacao}}</div>
                  </a>
                </td>
                <td class="align-middle text-right">
                  <div class="d-md-flex justify-content-end">
                    <div v-if="c.tipo_comanda !== '4'">
                      <button class="btn btn-block py-2 btn-secondary mr-1 ml-auto my-2" style="width: 90px" title="Comprovante Pedidos" @click="$refs.listFinalizar.openListPedidos(c.id_comanda)">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-list-details mr-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                          <path d="M13 5h8" />
                          <path d="M13 9h5" />
                          <path d="M13 15h8" />
                          <path d="M13 19h5" />
                          <rect x="3" y="4" width="6" height="6" rx="1" />
                          <rect x="3" y="14" width="6" height="6" rx="1" />
                        </svg>
                        <span class="small d-block mt-1">Pedidos</span>
                      </button>
                    </div>
                    <div v-if="podeGerenciarVendas">
                      <button class="btn btn-block py-2 ml-auto my-2" :class="c.status === '1' ? 'btn-success' : 'btn-dark'"
                              @click="finalizarComanda(c.id_comanda)" title="Finalizar Comanda" style="width: 95px">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-credit-card" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="#fff" fill="none" stroke-linecap="round" stroke-linejoin="round">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                          <rect x="3" y="5" width="18" height="14" rx="3" />
                          <line x1="3" y1="10" x2="21" y2="10" />
                          <line x1="7" y1="15" x2="7.01" y2="15" />
                          <line x1="11" y1="15" x2="13" y2="15" />
                        </svg>
                        <span class="d-block small mt-1">{{ c.status === '1' ? 'Fechar' : 'Pagamentos' }}</span>
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center pt-2 px-md-2 pt-md-0 border-top" :class="{'hide': load}">
          <button class="btn btn-sm" :disabled="pesquisa.pagina === 1" @click="paginarComandas(-1)"><i class="fa fa-angle-left"></i> Voltar</button>
          <span class="small">Página: {{pesquisa.pagina}}</span>
          <button class="btn btn-sm" :disabled="comandas.length < 50" @click="paginarComandas(1)">Próximo <i class="fa fa-angle-right"></i></button>
        </div>
        <div class="modal-content-footer bg-light p-2 border-top">
          <button class="btn btn-dark p-3" @click="$emit('closeModal')">
            <i class="fa fa-chevron-left mr-2"></i>
            <span>Voltar</span>
          </button>
        </div>
      </div>
      <finalizar ref="adminFinalizar" :comanda="comanda" :totalComanda="totalComanda" @atualizarVenda="atualizarVenda" @comprovante="$emit('abrirComprovante', comanda, true)"/>
    </div>

    <lista-pedidos ref="listFinalizar"/>
    <caixa ref="adminCaixa" @finalizarVenda="finalizarVendas"/>
    <modal-option @imprimir="imprimirVenda"/>
  </div>
</template>

<script>
  import Loading from "../../../components/commons/Loading";
  import Caixa from "@/views/comanda/pdv/Caixa";
  import ModalOption from "@/components/pdv/ModalOption";

  export default {
    components: {ModalOption, Caixa, Loading},
    name: 'AdminVendas',
    props: ['pdv', 'tipo', 'id_cliente', 'opened'],
    data() {
      return {
        token: localStorage.getItem('key'),
        load: true,
        modal: 0,

        comandas: [],
        selecionadas: [],
        selTodas: false,
        comanda: null,
        totalComanda: 0,
        modalOpcoes: false,
        atendentes: [],

        pesquisa: {
          id: "",
          referencia: "",
          data: '',
          tipo: "",
          status: "1",
          id_usuario: "",
          pagina: 1
        }
      }
    },

    methods: {
      buscarComandas(clear, callback) {
        this.load = true;
        this.selecionadas = [];

        if (clear) {
          this.pesquisa.pagina = 1;
        }

        if (this.user.acessos.restringir_vendas === '1') {
          this.pesquisa.id_usuario = this.user.id_usuario;
        }

        this.$http.get('comandas/' + this.token, { params: this.pesquisa })
          .then(response => {
            this.load = false;
            this.pesquisa.id = '';
            this.comandas = response.data || [];

            if (callback) {
              callback();
            }

          }, res => {
            this.load = false;
            this.$swal(res.data.msg || 'Erro temporário');
        });
      },

      buscarColaboradores() {
        if (!this.colaboradores.length) {
          this.$req.buscarColaboradores(this, this.token);
        }
      },

      paginarComandas(page) {
        if ((this.pesquisa.pagina + page) > 0) {
          this.pesquisa.pagina = this.pesquisa.pagina + page;
          this.buscarComandas();
        }
      },

      atualizarVenda() {
        this.modalOpcoes = false;

        if (this.comandas.length > 1 && this.comanda) {
          this.comandas = this.comandas.filter(c => c.id_comanda !== this.comanda.id_comanda);

        } else {
          this.buscarComandas();
        }

        this.$swal({
          title: '',
          text: 'Deseja imprimir o comprovante desta venda?',
          buttons: ['Não','Sim'],
          dangerMode: true
        }).then((r) => {
          if (r) {
            this.comanda.status = '2';
            this.$emit('abrirComprovante', this.comanda);
          }
        });
      },

      solicitarFinalizar(msg) {
        this.$swal({
          text: msg || 'Deseja realmente fechar todas essas vendas?',
          buttons: ['Não','Sim'],
          dangerMode: true
        }).then((r) => {
          if (r) {
            this.finalizarVendas();
          }
        });
      },

      solcitarCancelamento() {
        if (!this.selecionadas.length) {
          return;
        }

        this.$helpers.confirmarSenhaAdm(this, this.cancelarVendas);
      },

      openRelatorio(relatorio) {
        let url = this.base_server + 'api/';

        switch (relatorio) {
          case 1:
            const ids = this.selecionadas.join(',')
            url += `comandas/vendas-produtos/${this.token}?ids=${ids}&pdf=true`;
            break;
        }

        this.$helpers.openArquivo(this, url, 'pdf');
      },

      finalizarVendas() {
        this.$store.state.load = "Não saia desta tela, este procedimento pode demorar um pouco.";
        this.$http.post('comandas/finalizar-todas/' + this.token, { comandas: this.selecionadas })
          .then(response => {
            this.$store.state.load = false;
            const data = response.data || {};

            switch (data.result) {
              case 'success':
                this.selecionadas = [];
                this.buscarComandas(true, () => {
                  const title = (data.erros || 0) ? `Sucesso! Vendas não finalizadas: ${data.erros}\nPor favor feche manualmente cada venda.` : 'Vendas fechadas com sucesso!';

                  if (this.selTodas && this.pesquisa.status === '1' && this.comandas.length) {
                    this.selecionarVendas();
                    this.solicitarFinalizar(`${title}. Deseja continuar e fechar as demais vendas?`);

                  } else {
                    this.selTodas = false;
                    this.$swal("Sucesso", title);
                  }
                });

                if (this.$route.name === "NovoPDV") {
                  this.$emit('atualizar');
                }

                break;
              case 'caixa':
                this.$refs.adminCaixa.abrirCaixa();
                break;

              default:
                this.$swal("Atenção!", (data.msg || data.message || 'Erro temporário'));
                break;
            }

          }, res => {
            this.load = false;
            this.$store.state.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
          });
      },

      cancelarVendas() {
        this.$swal({
          title: '',
          text: 'Deseja realmente cancelar todas essas vendas?',
          buttons: ['Não','Sim'],
          dangerMode: true
        }).then((r) => {
          if (r) {
            this.$store.state.load = "Não saia desta tela, este procedimento pode demorar um pouco.";
            this.$http.post('comandas/cancelar-todas/' + this.token, { comandas: this.selecionadas })
              .then(res => {
                this.$store.state.load = false;
                this.$swal("Sucesso!","As vendas foram canceladas.");
                this.selecionadas = [];
                this.buscarComandas();

              }, res => {
                this.load = true;
                this.$store.state.load = false;
                this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
              });
          }
        });
      },

      limparSearch() {
        this.selecionadas = [];
        this.selTodas = false;
        this.pesquisa = {
          id: "",
          referencia: "",
          data: '',
          tipo: "",
          status: "1",
          id_usuario: "",
          pagina: 1
        };

        if (this.id_cliente) {
          this.pesquisa.status = "";
          this.pesquisa.id_cliente = this.id_cliente;
        }

        this.buscarComandas();
      },

      openComanda(c) {
        this.$emit('closeModal');
        this.$emit('closeAll');

        if (this.$route.params.id !== c.id_comanda) {
          this.$router.push('/pdv/' + c.id_comanda);
        }
      },

      finalizarComanda(id_comanda) {
        this.$store.state.load = true;
        this.getComandaId(id_comanda, () => {
          let total = 0;
          this.comanda.itens.forEach((obj) => {
            total += parseFloat(obj.valor_total);
          });

          this.totalComanda = parseFloat(total.toFixed(2));
          this.$nextTick(() => {
            this.$refs.adminFinalizar.openFinalizar();
          });
        })
      },

      getComandaId(id_comanda, callback) {
        this.$http.get('comandas/' + this.token + '/' + id_comanda)
          .then(response => {
            this.$store.state.load = false;

            if (response.data.id_comanda) {
              this.comanda = response.data;
              this.$nextTick(() => {
                callback();
              });
            }

          }, res => {
            this.$store.state.load = false;
          });
      },

      selecionarVendas() {
        if (this.pesquisa.status === '1' && this.comandas.length) {
          this.selecionadas = this.selecionadas.length === this.comandas.length ? [] : this.comandas.map(c => { return c.id_comanda });
          this.selTodas = !!this.selecionadas.length;
        }
      },

      imprimirVenda(id_comanda) {
        if (!id_comanda) {
          return;
        }

        const empresa = localStorage.getItem('token');
        const url = this.base_server + "api/comprovante/" + empresa + "/" + id_comanda + "?";
        this.$helpers.imprimirUrl(this, url, empresa, "Comprovante " + id_comanda);
      },

      getEnumDelivery(c) {
        let tipo = "";
        switch (c.pedido_delivery) {
          case '2':
            tipo = 'iFood'
            break;
          case '3':
            tipo = 'UaiRango'
            break;
          default:
            tipo = 'LeCard';
            break;
        }

        return tipo;
      }
    },

    computed: {
      user() {
        return this.$store.state.dataUser
      },

      colaboradores() {
        return this.$store.state.colaboradores;
      },

      podeGerenciarVendas() {
        return this.user.id_funcao <= 2 && this.user.acessos.bloquear_finalizar !== '1';
      }
    },

    watch: {
      opened(val) {
        if (val) {
          this.modal = 1;
          this.limparSearch();
        }
      }
    }
  }
</script>

<style scoped>
 .hide {
   visibility: hidden;
 }
 .height-90 {
   height: calc(100vh - 250px);
 }
</style>
